export const RouterV1 = "0x60aE616a2155Ee3d9A68541Ba4544862310933d4"
export const AvaxAdress = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"